// axios
import axios from "axios";
import { baseURL } from "./productionStatus";

export default axios.create({
  baseURL
});
